define([
	"dojo/_base/declare",
	"./UTCController",
	"csi/resolver",
	"dojo/_base/array",
	"csi/state/rootStore"
], function(declare, Controller, resolver, array, { sessionStore }) {
	
	return declare(Controller, {
		
		constructor: function(/*Object*/params) {
			const node = this.getNode();
			const responses = [];
			let i = 0;
			
			for (i in node.OpenResponses ){
				responses.push(node.OpenResponses[i]);
			}
			
			array.forEach(responses, function(response) { 
				const actionItemStepResponse = resolver.resolveNode(response, false, this.m_cache);
				if(actionItemStepResponse && actionItemStepResponse.User == sessionStore.currentUser.$URL) {
						this.m_urlNode = actionItemStepResponse.$URL;
				}
			}, this);
			
		}
	});
});